const addDotButtonsAndClickHandlers = (emblaApi, dotsNode) => {
  let dotNodes = [];
  const classLink = "c-embla-dots__link";
  const classSelected = "c-embla-dots__link--selected";
  const addDotButtonsWithClickHandlers = () => {
    dotsNode.innerHTML = emblaApi
      .scrollSnapList()
      .map(() => `<button class="${classLink}" type="button"></button>`)
      .join("");

    const scrollTo = (index) => {
      emblaApi.scrollTo(index);
    };

    dotNodes = Array.from(dotsNode.querySelectorAll(`.${classLink}`));
    dotNodes.forEach((dotNode, index) => {
      dotNode.addEventListener("click", () => scrollTo(index), false);
    });
  };

  const toggleDotButtonsActive = () => {
    const previous = emblaApi.previousScrollSnap();
    const selected = emblaApi.selectedScrollSnap();
    dotNodes[previous].classList.remove(classSelected);
    dotNodes[selected].classList.add(classSelected);
  };

  emblaApi
    .on("init", addDotButtonsWithClickHandlers)
    .on("reInit", addDotButtonsWithClickHandlers)
    .on("init", toggleDotButtonsActive)
    .on("reInit", toggleDotButtonsActive)
    .on("select", toggleDotButtonsActive);

  return () => {
    dotsNode.innerHTML = "";
  };
};

export { addDotButtonsAndClickHandlers };
